
import { useState } from 'react';
import { offerte } from '../../../mocks/offers';

const OffersSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % offerte.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + offerte.length) % offerte.length);
  };

  return (
    <section className="py-16 bg-[#8B9D7C] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <pattern id="leaf-pattern-offers" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
            <path d="M40 10 Q50 25 40 40 Q30 25 40 10" fill="currentColor" className="text-white" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#leaf-pattern-offers)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="inline-block px-6 py-2 border border-white rounded-full mb-6">
              <span className="text-white text-sm font-medium">Offerte Esclusive</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight">
              Promozioni<br />del Mese
            </h2>
            <p className="text-white/85 text-lg leading-relaxed mb-8">
              Approfitta delle nostre offerte speciali su prodotti selezionati. 
              Qualità biologica a prezzi vantaggiosi per te.
            </p>
            <button className="px-8 py-4 bg-white text-[#2D5016] rounded-full text-base font-medium hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap inline-flex items-center">
              Vedi Tutte le Offerte
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>

          <div className="lg:col-span-3">
            <div className="relative">
              <div className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-product-shop>
                <div className="grid grid-cols-1 md:grid-cols-5">
                  <div className="md:col-span-2 relative h-64 md:h-auto">
                    <img
                      src={offerte[currentIndex].immagine}
                      alt={offerte[currentIndex].prodotto}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4 w-16 h-16 bg-[#C17A5B] rounded-full flex items-center justify-center shadow-lg">
                      <div className="text-center">
                        <div className="text-white text-xl font-bold">-{offerte[currentIndex].sconto}%</div>
                      </div>
                    </div>
                  </div>

                  <div className="md:col-span-3 p-8 flex flex-col justify-center">
                    <h3 className="text-2xl font-bold text-[#2D5016] mb-3">
                      {offerte[currentIndex].prodotto}
                    </h3>
                    <p className="text-gray-600 mb-6">
                      {offerte[currentIndex].descrizione}
                    </p>
                    <div className="flex items-baseline gap-3 mb-6">
                      <span className="text-3xl font-bold text-[#2D5016]">
                        €{offerte[currentIndex].prezzoScontato}
                      </span>
                      <span className="text-xl text-gray-400 line-through">
                        €{offerte[currentIndex].prezzoOriginale}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mb-6">
                      <i className="ri-time-line mr-1"></i>
                      Valido fino al {offerte[currentIndex].validoFino}
                    </p>
                    <a
                      href="mailto:info@azienda.com"
                      className="w-4/5 mx-auto block px-6 py-3 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Info-disponibilità-prezzi x mail
                    </a>
                  </div>
                </div>
              </div>

              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-[#2D5016] text-xl"></i>
              </button>

              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-[#2D5016] text-xl"></i>
              </button>

              <div className="flex justify-center gap-2 mt-6">
                {offerte.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      index === currentIndex ? 'bg-white w-8' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffersSection;
